import { Link } from 'types/Link';
import { createMandatoryContext } from './utils';

export type HandleSelectedLinkChangeInputProps = {
  isAdmin?: boolean;
  newSelectedLink: Link;
};

export type HandleSelectedLinkChangeType = (
  input: HandleSelectedLinkChangeInputProps,
) => void;

interface SelectedLinkContextType {
  selectedLink?: Link;
  handleSelectedLinkChange: HandleSelectedLinkChangeType;
}

const [useSelectedLinkContext, SelectedLinkProvider] = createMandatoryContext<SelectedLinkContextType>();

export { useSelectedLinkContext, SelectedLinkProvider };